export const publicRoutes = [
  { path: '/', label: 'Accueil' },
  { path: '/logements', label: 'Logements' },
  { path: '/logements/carte', label: 'Carte' },
  { path: '/guide', label: 'Guide' },
  { path: '/communautes', label: 'Communauté' },
];

export const protectedRoutes = {
  student: [
    { path: '/dashboard/student', label: 'Tableau de bord' },
    { path: '/demarches', label: 'Mes démarches' },
    { path: '/favoris', label: 'Mes favoris' },
    { path: '/messages', label: 'Messages' },
    { path: '/profil', label: 'Mon profil' },
  ],
  owner: [
    { path: '/dashboard/owner', label: 'Tableau de bord' },
    { path: '/mes-logements', label: 'Mes logements' },
    { path: '/messages', label: 'Messages' },
    { path: '/profil', label: 'Mon profil' },
  ],
  admin: [
    { path: '/dashboard/admin', label: 'Tableau de bord' },
    { path: '/admin/utilisateurs', label: 'Utilisateurs' },
    { path: '/admin/guide', label: 'Guide' },
    { path: '/messages', label: 'Messages' },
    { path: '/profil', label: 'Mon profil' },
  ],
  service_acad: [
    { path: '/dashboard/service_acad', label: 'Tableau de bord' },
    { path: '/demarches', label: 'Démarches' },
    { path: '/messages', label: 'Messages' },
    { path: '/profil', label: 'Mon profil' },
  ],
};
